// extracted by mini-css-extract-plugin
export default {"container":"A30ls3","interaction":"wJaH9f","heading":"T8QaX3","login":"LJNDfa","buttonWrapper":"dYGufU","button":"IpwEWe","button1":"gqn1ae","register":"bgOLIN"};